import { Injectable, inject } from '@angular/core';

import { first } from 'rxjs';

import { SharedFeaturesApiService } from '../http/shared-features-api.service';
import { UserService } from '../user/user.service';
import { DslCacheService } from './dsl-cache.service';
import { DSL_NOT_READY } from './dsl-recorder.service';

export class CampaignData {
    action: string;
    campaign: string;
    group: string;
    templateId: string;
    rewardAttributes: { [key: string]: string };
}

@Injectable({
    providedIn: 'root',
})
export class UserGroupAttributesResolver {
    private readonly sharedFeaturesApiService = inject(SharedFeaturesApiService);
    private readonly user = inject(UserService);
    private readonly dslCacheService = inject(DslCacheService);

    private loaded = false;
    private campaigns: CampaignData[];

    userGroupAttribute(group: string, groupAttribute: string): any {
        if (!this.user.isAuthenticated) {
            return false;
        }

        if (!this.loaded) {
            this.loaded = true;
            this.load();
        }

        return this.campaigns ? this.campaigns.find((x) => x.action === group)?.rewardAttributes[groupAttribute] : DSL_NOT_READY;
    }

    private load() {
        this.sharedFeaturesApiService
            .get('usergroupattributes')
            .pipe(first())
            .subscribe((data: { campaigns: CampaignData[] }) => {
                this.campaigns = data.campaigns;
                this.dslCacheService.invalidate(['user.userGroupAttribute']);
            });
    }
}
